import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import GenericTable from "../../components/0. Tablas/CursoTable";
import CursosView from "../../components/1.2 cursos/Curso";
import LoadingOverlay from "../../components/0. Utilidades/LoadingOverlay";
import { getApiUrl } from "../../utils/apiUrl";

const CursoPage = () => {
  const { id } = useParams();
  const [selectedCurso, setSelectedCurso] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let isActive = true;

    if (id) {
      setLoadingDetail(true);
      fetch(getApiUrl(`api/perfiles/cursos/${id}/`), {
        credentials: "include",
      })
        .then((res) => {
          if (!res.ok) throw new Error("No se pudo cargar el curso.");
          return res.json();
        })
        .then((data) => {
          if (!isActive) return;
          setSelectedCurso(data);
          setShowModal(true);
          setLoading(false);
        })
        .catch((err) => {
          if (!isActive) return;
          console.error("Error:", err);
          setLoading(false);
        })
        .finally(() => {
          if (isActive) setLoadingDetail(false);
        });
    } else {
      setSelectedCurso(null);
      setShowModal(false);
      setLoading(false);
      setLoadingDetail(false);
    }

    return () => {
      // Let Django finish the response and ignore stale results instead of
      // aborting the socket, which can surface as BrokenPipeError server-side.
      isActive = false;
    };
  }, [id]);

  const handleCursoSelect = (curso) => {
    setLoadingDetail(true);
    setShowModal(false);
    setSelectedCurso(null);
    navigate(`/cursos/${curso.id}`);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCurso(null);
    navigate("/cursos");
  };

  const columns = [
    { Header: "Nombre", accessor: "nombre" },
    { Header: "Comuna", accessor: "comuna" },
    { Header: "Oficio", accessor: "oficio" },
  ];

  if (loading) return <LoadingOverlay />;

  return (
    <>
      {(loading || loadingDetail) && <LoadingOverlay />}
      <div className="curso-page capsule">
        <GenericTable
          apiUrl={getApiUrl("api/perfiles/tabla/cursos/")}
          columns={columns}
          onRowClick={handleCursoSelect}
          category="cursos"
        />

        {showModal && selectedCurso && (
          <Modal
            show={showModal}
            onHide={handleCloseModal}
            size="xl"
            backdrop="static"
            dialogClassName="modal-100w"
          >
            <Modal.Body className="curso-detail-modal position-relative">
              <button
                className="btn btn-sm btn-danger position-absolute top-0 end-0 m-3"
                onClick={handleCloseModal}
              >
                &times;
              </button>
              <CursosView curso={selectedCurso} />
            </Modal.Body>
          </Modal>
        )}
      </div>
    </>
  );
};

export default CursoPage;
